import { Equipment } from 'fallout/src/app/fww/global/models';

export function isPowerArmor(equipment: Equipment) {
    return equipment?.type === 'Power Armor';
}

export function isUndamagedPowerArmour(equipment: Equipment) {
    return isPowerArmor(equipment) && !equipment?.damaged;
}

export function isDamagedPowerArmour(equipment: Equipment) {
    return isPowerArmor(equipment) && equipment?.damaged;
}
